import React from 'react';

const OwnershipTemplates = () => <div>Ownership Templates & Resources</div>;

export default OwnershipTemplates;
